/* eslint-disable complexity */
/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useMemo, useContext, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { FormLayoutHeader } from 'components/FormHelpersPlain';
import _ from 'lodash';
import { AppContext } from '@ctsu/loader';
import { openConfirmation } from 'helpers/Confirmation';
import { bindActionCreators } from 'redux';
import { updateStatusTransaction } from 'actions/protocols/admin';
import {
    getApiDTFormat
} from 'helpers';
import { bindLogger } from 'helpers/BindLogger';
import { httpStatusEnum } from 'appconstants';
import { openSnackbar } from 'helpers/Notifier';
import { useSelector, useDispatch } from 'react-redux';

const StatusTransaction = props => {
    const context = useContext(AppContext);
    const {
        grpProtStatusDate,
        grpProtStatus,
        pioStatus,
        prtId,
        protocolNumber,
        statusChangeInfo
    } = useSelector(data => data.prtDetails.prtInfo);

    // const { rationale, statusReason, otherSpecify } = statusChangeInfo;

    const dispatch = useDispatch();
    const actions = useMemo(() => bindActionCreators({ updateStatusTransaction }, dispatch), [dispatch]);


    const [initialState, setInitState] = useState({
        rqtGrpStatusFrom: null,
        rqtGrpProtStatusTo: null,
        otherSpecify: '',
        rationale: null,
        statusReason: null,
        toProtStatusDate: null
    });

    useEffect(() => {
        if (!_.isEmpty(grpProtStatus)) {
            setInitState(prevState => {
                return {
                    ...prevState,
                    rqtGrpProtStatusTo: grpProtStatus
                };
            });
        }
        if (!_.isEmpty(pioStatus)) {
            setInitState(prevState => {
                return {
                    ...prevState,
                    rqtGrpStatusFrom: pioStatus
                };
            });
        }
        if (!_.isEmpty(grpProtStatusDate)) {
            setInitState(prevState => {
                return {
                    ...prevState,
                    toProtStatusDate: grpProtStatusDate
                };
            });
        }
        if (!_.isEmpty(statusChangeInfo)) {
            const { rationale, statusReason, otherSpecify } = { ...statusChangeInfo };
            setInitState(prevState => {
                return {
                    ...prevState,
                    rationale,
                    statusReason,
                    otherSpecify
                };
            });
        }
    }, [grpProtStatus, grpProtStatusDate, pioStatus, statusChangeInfo]);


    const onSaveStatusTransaction = (values) => {
        const data = {
            ...values,
            toProtStatusDate: getApiDTFormat(values.toProtStatusDate)
        };
        delete data.rqtGrpStatusFrom;
        bindLogger(actions.updateStatusTransaction, context)(data, prtId).subscribe(
            resp => {
                if (resp.status === httpStatusEnum.SUCCESS) {
                    openSnackbar({
                        message: `${protocolNumber} protocol status transaction generated.`,
                        variant: 'success',
                        name: 'status_transaction'
                    });
                }
            }
        );
    }
    const onSubmit = (values) => {
        const confirmSave = () => {
            onSaveStatusTransaction({
                ...values
            });
        };
        openConfirmation({
            message: 'This transaction is about to be generated. Please confirm',
            onAction: confirmSave,
            name: 'status_transaction'
        });
    };

    return (
        <>
            <div className="form-layout-wrapper mb-3" >
                <Formik
                    initialValues={initialState}
                    enableReinitialize
                    onSubmit={onSubmit}
                >
                    {
                        formik => {
                            // eslint-disable-next-line no-shadow
                            const { rqtGrpStatusFrom, rqtGrpProtStatusTo, otherSpecify, rationale, statusReason, toProtStatusDate } = formik.values || {};
                            return (
                                <>
                                    <FormLayoutHeader title="Generate Protocol Status Transaction">
                                        <div className="d-flex row">
                                            <button
                                                className="mr-3 btn turquoise"
                                                type="submit"
                                                disabled={rqtGrpProtStatusTo === rqtGrpStatusFrom}
                                            >
                                                Generate START Transaction
                                            </button>
                                        </div>
                                    </FormLayoutHeader>
                                    <Form>
                                        <div className="form-layout-body no-line">
                                            <ul className="mb-1">
                                                <li>
                                                    <label htmlFor="rqtGrpStatusFrom">
                                                        From Protocol Status
                                                    </label>
                                                    <div name="rqtGrpStatusFrom" className="form-layout-input">{rqtGrpStatusFrom}</div>
                                                </li>
                                                <li>
                                                    <label htmlFor="rqtGrpProtStatusTo">
                                                        To Protocol Status
                                                    </label>
                                                    <div name="rqtGrpProtStatusTo" className="form-layout-input">{rqtGrpProtStatusTo}</div>
                                                </li>
                                                <li>
                                                    <label htmlFor="toProtStatusDate">
                                                        Status Date
                                                    </label>
                                                    <div name="toProtStatusDate" className="form-layout-input">{toProtStatusDate}</div>
                                                </li>
                                                <li>
                                                    <label htmlFor="rationale">
                                                        Rationale
                                                    </label>
                                                    <div name="rationale" className="form-layout-input">{rationale}</div>
                                                </li>
                                                <li>
                                                    <label htmlFor="statusReason">
                                                        Reason
                                                    </label>
                                                    <div name="statusReason" className="form-layout-input">{statusReason}</div>
                                                </li>
                                                <li>
                                                    <label htmlFor="otherSpecify">
                                                        Other Specify
                                                    </label>
                                                    <div name="otherSpecify" className="form-layout-input">{otherSpecify}</div>
                                                </li>
                                            </ul>
                                        </div>
                                    </Form>
                                </>
                            );
                        }
                    }
                </Formik>
            </div>
        </>
    );
};

export default StatusTransaction;